import { Text, View } from "react-native";

import { ReactComponent as MoreImg } from '../../../img/ico-prefix-more-dashboard.svg';
import { FONT } from "../../../value/staticValues";


import DashboardBox from "../../base/tamplate/DashboardBox";
import ProgressBar from "./ProgressBar";

interface VerticalProgressProps {
    navigate: Function;
    url?: string;
    title: string;
    data: number;
    total: number;
    percent: number;
    unit?: string;
    color: string;
}

export default function VerticalProgress(props:VerticalProgressProps) {
    return (
        <DashboardBox style={{
            width: 160, height: 320,
            marginRight: 10,
        }}>
            <View style={{flexDirection: "row", alignItems: "center", height: 20}}>
                <Text style={{
                    fontFamily: FONT.MEDIUM,
                    fontSize: 14,
                    lineHeight: 13,
                    color: "#262626"
                }}>
                    {props.title}
                </Text>
                {props.url ?
                    <MoreImg 
                        style={{marginLeft: "auto", cursor: "pointer"}}
                        onClick={() => {props.navigate(`${props.url}`)}}
                    />
                :null }
            </View>
            <View style={{marginTop: 80, alignItems: "center"}}>
                <Text style={{
                    fontFamily: FONT.BOLD,
                    fontSize: 32,
                    color: "#333"
                }}>
                    {props.data}
                </Text>
                <Text style={{
                    marginTop: 15,
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#333"
                }}>
                    Used
                </Text>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "center",
                    minWidth: 80, height: 24,
                    paddingLeft: 10, paddingRight: 10,
                    marginTop: 25,
                    borderRadius: 18,
                    borderWidth: 1, borderColor: "#e4e1eb"
                }}>
                    <Text style={{
                        fontFamily: FONT.REGULAR,
                        fontSize: 10,
                        color: "#808080"
                    }}>
                        Total {props.total} {props.unit}
                    </Text>
                </View>
            </View>
            <View style={{marginTop: "auto"}}>
                <ProgressBar
                    color={props.color}
                    percent={props.percent}
                />
            </View>
        </DashboardBox>
    )
}